import {Presenter} from "@/Master/Presenter";
import {SRewardPresenter} from "@/app/_components/Coin/SRewardPresenter";
import {SRewardAnimation} from "@/app/_components/Coin/SRewardAnimation";
import {DriveUtil} from "@/Master/DriveUtil";
import {RewardType} from "@/Core/Reward/RewardInfo";
import LoginNetManager from "@/Core/Login/LoginNetManager";
import UserGlobalMgr from "@/Core/UserGlobalMgr";


// 事件类型枚举
export enum EventType {
    OnGcUpdate,
    OnScUpdate,
}

// 效果类型枚举
export enum EffectType {
    None,       // 不更新
    Update,     // 直接刷新
    NumberRoll, // 数字滚动
    FlyIcon,    // 图标飞入动画
}

export class SRewardUIPresenter extends Presenter<SRewardUIPresenter>{
    public static Instance: SRewardUIPresenter = new SRewardUIPresenter();
    public static EventType = {
        OnGcUpdate: 0,
        OnScUpdate: 1,
    } as const;


    // public listener = new SRewardUIPresenter.Listener();

    // 原本的 gcAmount 与 scAmount 是私有可写属性，这里使用私有字段和公共只读访问器
    private _gcAmount: number = 0;
    private _scAmount: number = 0;

    public get gcAmount(): number {
        return this._gcAmount;
    }

    public get scAmount(): number {
        return this._scAmount;
    }

    public static get gcCount(): number {
        return SRewardUIPresenter.Instance.gcAmount;
    }

    public static get scCountAtom(): number {
        return SRewardUIPresenter.Instance.gcAmount;
    }

    public static get scCount(): number {
        return SRewardUIPresenter.Instance.scAmount;
    }

    public PlayFlyAnimation(gc: number, sc: number, effectPanelPos?: { x: number; y: number }): void {
        if (gc > 0) {
            this.PlayAnimation(RewardType.GC, gc, EffectType.FlyIcon, effectPanelPos);
        }
        if (sc > 0) {
            this.PlayAnimation(RewardType.SC, DriveUtil.ToAtomUnit(sc), EffectType.FlyIcon, effectPanelPos);
        }
    }

    public PlayRewardAnimation(gc: number, sc: number, collectEffectType: EffectType): void {
        if (gc > 0) {
            this.PlayGcAnimation(gc, collectEffectType);
        }

        if (sc > 0) {
            this.PlayScAnimation(sc, collectEffectType);
        }
    }

    public PlayGcAnimation(value: number, type: EffectType): void {
        this.PlayAnimation(RewardType.GC, value, type);
    }

    public PlayScAnimation(value: number, type: EffectType): void {
        this.PlayAnimation(RewardType.SC, DriveUtil.ToAtomUnit(value), type);
    }


    // 通用播放动画方法
    private PlayAnimation(rewardType: RewardType, value: number, type: EffectType, startFlyPos?: { x: number; y: number }): void {
        if (value <= 0) return;

        // 更新当前的金额数据
        if (rewardType === RewardType.GC) {
            this._gcAmount = SRewardPresenter.gcCount;
        } else if (rewardType === RewardType.SC) {
            this._scAmount = SRewardPresenter.scCountAtom;
        }

        switch (type) {
            case EffectType.None:
                // 不做更新
                break;
            case EffectType.Update:
                // 直接刷新UI显示
                if (rewardType === RewardType.GC) {
                    // SRewardAnimation.UpdateRewardLabelText(rewardType, this._gcAmount);
                } else if (rewardType === RewardType.SC) {
                    // SRewardAnimation.UpdateRewardLabelText(rewardType, this._scAmount);
                }
                this.OnUpdateComplete(rewardType);
                break;
            case EffectType.NumberRoll:
                // 数字滚动特效
                SRewardAnimation.PlayNumberRoll(rewardType, value, () => this.OnUpdateComplete(rewardType));
                break;
            case EffectType.FlyIcon:
                // 图标飞入特效
                SRewardAnimation.PlayFlyIcon(rewardType, value, () => this.OnUpdateComplete(rewardType), startFlyPos);
                break;
            default:
                console.error(`未知的类型: ${type}`);
                break;
        }
    }

    // 更新完成后调用
    private OnUpdateComplete(type: RewardType): void {
        switch (type) {
            case RewardType.GC:
                // this.listener.EmitEvent(EventType.OnGcUpdate);
                break;
            case RewardType.SC:
                // this.listener.EmitEvent(EventType.OnScUpdate);
                break;
            default:
                console.error(`未知的类型:${type}`);
                break;
        }
    }

    // 添加忽略浮动标签
    // public AddIgnoreFloatLabel(dialog: SDialog): void {
    //     SRewardAnimation.config.AddIgnoreFloatLabel(dialog);
    // }
    UpdateGcCount() {
        UserGlobalMgr.updateUserBaseInfo();
    }

    UpdateScCount() {
        UserGlobalMgr.updateUserBaseInfo();
    }
}